<template>
  <x-float-view
    v-track="{
      name: '多多商城悬浮购物车',
      id: '71970d74-20ef-43c2-b9cc-5a01fbb4d783',
    }"
    :class="[_.cart, style2 && _.style2]"
    @click="handleClick"
  >
    <div :class="_.container">
      <x-icon
        :src="
          style2
            ? require('./images/购物车.svg')
            : require('./images/悬浮购物车.png')
        "
        :class="_.icon"
      />
      <div v-if="count" :class="_.counter">
        {{ 99 >= count ? count : '99+' }}
      </div>
    </div>
  </x-float-view>
</template>

<script>
  import Vue from 'vue'
  import { apiShoppingCartQuantity } from '@/api'
  import { ensureP } from '@/api/encrypt'
  import { navigateTo } from '@/router'
  import { onPageVisibilityChange } from '@/utils'

  export default Vue.extend({
    props: {
      style2: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      count: 0,
    }),

    mounted() {
      this.getCartCount()

      this._offVisibilityChange = onPageVisibilityChange(() => {
        this.getCartCount()
      })
    },

    beforeDestroy() {
      this._offVisibilityChange?.()
    },

    activated() {
      this.getCartCount()
    },

    methods: {
      getCartCount() {
        ensureP().then(() => {
          apiShoppingCartQuantity().then(res => {
            this.count = res.quantity
          })
        })
      },
      handleClick() {
        navigateTo('CartIndex')
      },
    },
  })
</script>

<style lang="scss" module>
  .cart {
    position: fixed;
    right: 9px;
    bottom: 120px;
    z-index: 1;

    .icon {
      width: 58px;
      height: 58px;
    }

    .counter {
      position: absolute;
      top: 0px;
      right: 0px;
      background: #ff3b30;
      border-radius: 1000px;
      border: 1px solid #ffffff;
      font-size: 12px;
      color: #ffffff;
      padding: 2px 4px;
      line-height: 1;
      min-width: 20px;
      min-height: 20px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &:active {
      filter: contrast(0.9);
    }

    &.style2 {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 44px;
      height: 44px;
      border-radius: 50%;
      box-shadow: 0px 4px 14px 0px rgba(0, 0, 0, 0.15);
      background: #ffffff;

      .icon {
        width: 24px;
        height: 24px;
      }

      .counter {
        top: 6px;
        right: 4px;
        min-width: 13px;
        min-height: 13px;
      }
    }
  }
</style>
